import { APP_ICON_URL, LOGO_URL, PRODUCT_NAME } from '../../constants/productBranding';

type AppLogoProps = {
  variant?: 'full' | 'icon';
  className?: string;
};

export function AppLogo({ variant = 'full', className = '' }: AppLogoProps) {
  const src = variant === 'icon' ? APP_ICON_URL : LOGO_URL;

  return (
    <img
      src={src}
      alt={PRODUCT_NAME}
      className={className}
    />
  );
}
